import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./pages/Home";
import Courses from "./pages/Courses";
import TrainingOFA from "./pages/TrainingOFA";
import CourseAbout from "./pages/CourseAbout";
import Suppliers from "./pages/Supplies";
import Learning from "./pages/Learning";
import CodeOfConduct from "./pages/CodeOfConduct";
import RefundPolicy from "./pages/RefundPolicy";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import BlogInside from "./components/Blog/BlogInside";
import Contact from "./pages/Contact";
import ContactDetail from "./pages/ContactDetail";
import PrivateContact from "./pages/PrivateContact";
import AboutUs from "./pages/AboutUs";
import SuppliesProduct from "./pages/SuppliesProduct";
import SuppliersProductView from "./pages/SuppliersProductView";
import Cart from "./pages/Cart";
import PaymentSuccessfull from "./pages/paymentSuccess";
import StundentDetails from "./pages/StundentDetails";
import Login from "./pages/Login";
import NotFoundPage from "./pages/NotFoundPage";
import { CartProvider } from "./components/Event/CartContext";
import PrivateRoute from "./PrivateRoute";
import AttendeeRegistrationForm from "./components/Event/RegistrationForm";
import PrivateGroupTraining from "./pages/PrivateGroupTraining";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ScrollToTop component to handle scroll behavior on route changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <CartProvider>
      <ToastContainer className="!z-[9999999]" />
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/all-courses" element={<Courses />} />
          <Route path="/training-worksafe/:name" element={<TrainingOFA />} />
          <Route path="/course-about/:name" element={<CourseAbout />} />
          <Route path="/supplies" element={<Suppliers />} />
          <Route path="/eLearning" element={<Learning />} />
          <Route
            path="/classroom-code-of-conduct"
            element={<CodeOfConduct />}
          />
          <Route
            path="/change-refund-return-policy"
            element={<RefundPolicy />}
          />
          <Route
            path="/private-group-training"
            element={<PrivateGroupTraining />}
          />
          <Route path="*" element={<NotFoundPage />} />
          <Route
            path="/event/:eventId/add-attendees"
            element={<AttendeeRegistrationForm />}
          />
          {/* <Route path='/about_us' element={<AboutUs />} /> */}
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog-inside/:id" element={<BlogInside />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contact/:id" element={<ContactDetail />} />
          <Route path="/contact-private" element={<PrivateContact />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/supplies_products" element={<SuppliesProduct />} />
          <Route
            path="/supplies-product-view"
            element={<SuppliersProductView />}
          />
          <Route path="/supplies-cart" element={<Cart />} />
          <Route path="/payment-successfull" element={<PaymentSuccessfull />} />
          {/* <Route path="/student/login" element={<Login />} */}
          <Route
            path="/student/dashboard"
            element={<PrivateRoute element={<StundentDetails />} />}
          />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
